import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconQuickSearch: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconQuickSearch"><Path d="M12 4C8.13401 4 5 7.13401 5 11H3C3 6.02944 7.02944 2 12 2C16.9706 2 21 6.02944 21 11C21 13.125 20.2635 15.078 19.0319 16.6177L22.2071 19.7929L20.7929 21.2071L17.6177 18.0319C16.078 19.2635 14.125 20 12 20V18C15.866 18 19 14.866 19 11C19 7.13401 15.866 4 12 4Z" fill="currentColor"/><Path d="M8.78571 10L3 16.875H6.85714L6.21429 21L12 14.125H8.14286L8.78571 10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconQuickSearch;
